// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ForecastsPayloadSchema = z.object({
  user_id: z.number().int().describe("User who will work on this task (required)"),
  project_id: z.number().int().describe("Project to task time against (required)"),
  hours: z.optional(z.number().int().min(0).describe("Task hours")),
  minutes: z.optional(z.number().int().min(0).max(59).describe("Task minutes")),
  day: z.coerce.string().describe("Date of task in YYYY-MM-DD format (required)"),
  note: z.coerce.string().describe("Description or notes for this task").nullish(),
});
